export enum BILLING_FORM_ADDRESS_NAME {
  SHIPPING = 'shipping',
  BILLING = 'billing'
}

export enum MIDDLEWARE {
  GET_LOCATION = "location-redirect",
  IS_AUTHENTICATED = "is-authenticated",
  IS_NOT_AUTHENTICATED = "is-not-authenticated",
  IS_ANONYMOUS_CART = "is-anonymous-cart",
  HAS_ERRORS = "has-errors",
  IS_RESTICTED_PAGE = "restrict-page-direct-access",
}

export const CART_USER = 'cart-user';
export const CART_ID_COOKIE_NAME = 'CART_ID';
export const ACCEPTED_COOKIES_COOKIE_NAME = 'cookies:accepted';

export enum IMAGE_TAGS {
  IMAGE = 'img',
  NUXT_IMAGE = 'nuxt-img'
}

export enum COOKIES {
  USER = "moomin-user-status",
  USER_TOKEN = "vsf-sap-token",
  LOCALE = 'vsf-locale',
  COUNTRY = 'vsf-country',
  CURRENCY = 'vsf-currency',
  STORE = 'vsf-store',
  ACCEPTED_COOKIES = 'cookies:accepted',
  CART_ID = 'CART_ID',
  SALESFORCE_CRM_TOKEN = 'sCt',
  COVEO_TOKEN = 'cTo',
  USER_DATA = 'moomin-user-data',
  CURRENT_USER_ID = 'current',
  SAPCC_TOKEN = 'spcTo',
  ADYEN_PAYMENT_METHODS='avlpm',
  COVEO_VISITOR_ID='coveo_visitorId',
  CONFIRMATION_LOCALE_CHANGE='keep_locale',
  MCRCCODE = 'mcrCCode',
  MCRCNTRY = 'mcrCntry'
}
